import swal from 'sweetalert';
import { getAuthHeader } from "./auth/unified-auth";
import { store } from "../redux/store";
import { setLoading } from "../redux/reducer/loaderSlice";
import showNotificationModal from '../components/Notification/NotificationModal.js';

/** OLD LOGIC **/
// export const CUSTOM_HEADER = {
//     // 'Authorization': `Bearer ${access_token}`,
//     'Content-Type': 'application/json',
//     ...getOktaAuthHeader()
//     // 'X-Frame-Options': 'DENY'
// };

const showErrorMessage = ()=>{
    showNotificationModal({
        title: 'Response Failed',
        text: 'Something went wrong, Please try later.',
        icon: 'warning',
        button: "Go Back"
    })
    .then(() => {
        console.log("api failed");
    });
}
export const handleApiResponse = (response) => {
    if (response) {
        if (response.status === 400 || response.status === 429 || response.status === 500 || response.status === 504 || response.status === 404) {
            // swal({
            //     title: 'Response Failed',
            //     text: 'Something went wrong, Please try later.',
            //     icon: 'error',
            //     button: "Refresh"
            // })
            //     .then(() => {
            //         console.log("api failed");

            //     })
            showErrorMessage();
        }
        if (response.status === 204) {
            return null; // or return { success: true }
        }
        return response.json();
    } else {
        return { message: 'Unexpected Response', data: response };
    }
};

const isNetworkError = (error) =>
    error instanceof TypeError && (
        error.message === 'Failed to fetch' ||
        error.message.includes('network') ||
        error.message.includes('ERR_HTTP2')
    );

const fetchWithRetry = async (url, options, retries = 2, baseDelay = 500) => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            return await fetch(url, options);
        } catch (error) {
            console.log(`Attempt ${attempt + 1} failed: ${error.message}`);
            if (isNetworkError(error) && attempt < retries) {
                await new Promise(resolve =>
                    setTimeout(resolve, baseDelay * Math.pow(2, attempt))
                );
            } else {
                throw error;
            }
        }
    }
};

export const getApiCall = async (url = '') => {
    store.dispatch(setLoading(true)); 
    try {
        const authHeader = await getAuthHeader();
        const CUSTOM_HEADER = {
            'Content-Type': 'application/json',
            ...authHeader
        };
        const response = await fetchWithRetry(url, { headers: CUSTOM_HEADER });
        store.dispatch(setLoading(false));
        return handleApiResponse(response);
    } catch (error) {
        store.dispatch(setLoading(false)); 
        showErrorMessage();
    }
};

export const postApiCall = async (url = '', body) => {
    let skipLoaderApis = ["sustainability/filter-details", "sustainability/suppliers-details", 
    "supplier-performance/filter-data", "/supplier-performance/inhouse-dropdown-filters", "/supplier-performance/spminhouse-filter",
    "supplier-risk/dropdown-filters","supplier-risk/resilinc-filters-api",
    "archlet/drop-down-filter-details",
    "/market-intelligence/dropdown-data", "/nps/save-feedback", 
    '/user-notification/notifications', '/user-notification/update-subscription', 
    '/user-notification/read', '/user-notification/read-all'];
    let skipLoaderDisplay = skipLoaderApis.some(word => url.includes(word));
    if(!skipLoaderDisplay){
        store.dispatch(setLoading(true));
    } 
    // store.dispatch(setLoading(true));
    try {
        const authHeader = await getAuthHeader();
        const CUSTOM_HEADER = {
            'Content-Type': 'application/json',
            ...authHeader
        };
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: CUSTOM_HEADER,
            body: JSON.stringify(body)
        })
        if(!skipLoaderDisplay){
            store.dispatch(setLoading(false));
        }
        return handleApiResponse(response);
    } catch (error) {
        store.dispatch(setLoading(false)); 
        // swal({
        //     title: 'Response Failed',
        //     text: 'Something went wrong, Please try later.',
        //     icon: 'error',
        //     button: "Refresh"
        // })
        
        showErrorMessage();
    }
}


export const postApiCallWithAbort = async (url = '', body, signal) => {
    let skipLoaderApis = ["sustainability/filter-details", "sustainability/suppliers-details", 
    "supplier-performance/filter-data", "/supplier-performance/inhouse-dropdown-filters",
    "/market-intelligence/dropdown-data"];
    let skipLoaderDisplay = skipLoaderApis.some(word => url.includes(word));
    if(!skipLoaderDisplay){
        store.dispatch(setLoading(true));
    } 
    // store.dispatch(setLoading(true));
    try {
        const authHeader = await getAuthHeader();
        const CUSTOM_HEADER = {
            'Content-Type': 'application/json',
            ...authHeader
        };
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: CUSTOM_HEADER,
            body: JSON.stringify(body),
            signal, // this line enables cancellation
        })
        if(!skipLoaderDisplay){
            store.dispatch(setLoading(false));
        }
        return handleApiResponse(response);
    } catch (error) {
        if (error.name === 'AbortError') {
            store.dispatch(setLoading(true));
            console.log("Previous request aborted.");
            // return;
        } else {
            store.dispatch(setLoading(false)); 
            // swal({
            //     title: 'Response Failed',
            //     text: 'Something went wrong, Please try later.',
            //     icon: 'error',
            //     button: "Refresh"
            // })
            showErrorMessage();
        }
    }
}

export const patchApiCall = async (url = '', body) => {
    try {
        const authHeader = await getAuthHeader();
        const CUSTOM_HEADER = {
            'Content-Type': 'application/json',
            ...authHeader
        };
        const response = await fetch(url, {
            method: 'PATCH',
            mode: 'cors',
            headers: CUSTOM_HEADER,
            body: JSON.stringify(body)
        })
        return handleApiResponse(response);
    } catch (error) {
        store.dispatch(setLoading(false)); 
        
        showErrorMessage();
    }
}

export const putApiCall = async (url = '', body) => {
    let skipLoaderApis = ["user/walkme"];
    let skipLoaderDisplay = skipLoaderApis.some(word => url.includes(word));
    if(!skipLoaderDisplay){
        store.dispatch(setLoading(true));
    } 
    // store.dispatch(setLoading(true)); 
    const authHeader = await getAuthHeader();
    const CUSTOM_HEADER = {
        'Content-Type': 'application/json',
        ...authHeader
    };
    const response = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        headers: CUSTOM_HEADER,
        body: JSON.stringify(body)
    })
    return handleApiResponse(response);
}

export const deleteApiCall = async (url = '', body) => {
    store.dispatch(setLoading(true)); 
    const authHeader = await getAuthHeader();
    const CUSTOM_HEADER = {
        'Content-Type': 'application/json',
        ...authHeader
    };
    const response = await fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        headers: CUSTOM_HEADER,
        body: JSON.stringify(body)
    })
    return handleApiResponse(response);
}